import { useReduxSelector } from 'hooks/store';

export default function useIsBeta() {
  const environment = useReduxSelector((state) => state.environment.REACT_APP_ENV);
  return environment === 'beta';
}
